module.exports = __webpack_public_path__ + "static/media/om_lipshape_downturned.e540d100.png";